'use strict';

const _ = require('underscore');
const Comment = require('communication/domain/entity/comment');
const CommentReactionFactory = require('communication/domain/comment-reaction/reaction-factory');

class Factory {
    constructor(project) {
        this._project = project;
    }

    _fetchReactions(reactionsJSON) {
        const reactionFactory = new CommentReactionFactory(this._project);

        return Promise.all(
            _.map(
                reactionsJSON,
                reactionJSON => {
                    return reactionFactory.build(reactionJSON);
                }
            )
        );
    }

    build(json) {
        return new Promise((resolve, reject) => {
            const reactionsJSON = json.reactions || [];

            Promise.all([
                this._fetchReactions(reactionsJSON)
            ]).then((values) => {
                const reactions = values[0];
                json.reactions = reactions;
                resolve(new Comment(json));
            });
        });
    }
}

module.exports = Factory;



// WEBPACK FOOTER //
// ./communication/domain/factory/comment.js